import { Directive, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MultiSelect } from 'primeng/multiselect';
import { Dropdown } from 'primeng/dropdown';

@Directive({
    selector: 'p-multiSelect',
    standalone: false
})
export class ClearMultiSelectFilterOnOpenDirective implements OnInit, OnDestroy {
    private sub = new Subscription();

    constructor(private ms: MultiSelect) {}

    ngOnInit() {
        this.sub.add(
            this.ms.onPanelShow.subscribe(() => this.ms.resetFilter())
        );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}

@Directive({
    selector: 'p-dropdown',
    standalone: false
})
export class ClearDropdownFilterOnOpenDirective implements OnInit, OnDestroy {
    private sub = new Subscription();

    constructor(private dd: Dropdown) {}

    ngOnInit() {
        this.sub.add(
            this.dd.onShow.subscribe(() => {
                if (this.dd.filter) this.dd.resetFilter();
            })
        );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }
}
